import { render, staticRenderFns } from "./Germany.vue?vue&type=template&id=545407d4&scoped=true"
import script from "./Germany.vue?vue&type=script&lang=js"
export * from "./Germany.vue?vue&type=script&lang=js"
import style0 from "./country.css?vue&type=style&index=0&id=545407d4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_cache-loader@4.1.0_webpack@4.47.0__css-load_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545407d4",
  null
  
)

export default component.exports